import { connect } from "react-redux";
import Invoices from "../components/Profile/Invoices/Invoices";

const mapStateToProps = (state: any) => {
	return {
		clubLogo: state.auth.clubLogo,
		userConfig: state.auth.userConfig,
		billingProfiles: state.billingProfile.billingProfiles,
		messages: state.billingProfile.messages,
		errors: state.billingProfile.errors,
		successful: state.billingProfile.successful,
		requesting: state.billingProfile.requesting,
		getRequest: state.invoices.getRequest,
		getSuccess: state.invoices.getSuccess,
		userInfo: state.client.user,
		clubData: state.billingProfile.clubData,
		invoices: state.invoices.invoices,
		invoiceDetails: state.invoices.invoiceDetails,
		credits: state.client.credits,
		emailError: state.invoices.errors,
		emailMessage: state.invoices.messages,
		paymentMessage: state.invoices.messages,
		paymentError: state.invoices.errors,
		paymentRequesting: state.invoices.requesting,
		paymentSuccessful: state.invoices.successful,
		invoicePdf: state.invoices.invoicePdf,
		pdfRequesting: state.invoices.pdfRequesting,
		pdfSuccessful: state.invoices.pdfSuccessful,
		pdfError: state.invoices.pdfError,
		creditsSuccess: state.client.creditsSuccess,
	};
};

const mapDispatchToProps = (dispatch: any) => {
	return {
		emailInvoice: (config: any) =>
			dispatch({ type: "EMAIL_INVOICE_REQUEST", value: config }),
		getProfileInfo: (config: any) =>
			dispatch({ type: "PROFILE_INFO_REQUEST", value: config }),
		getInvoices: (config: any) =>
			dispatch({ type: "GET_INVOICES_REQUEST", value: config }),
		getInvoicePdf: (config: any) =>
			dispatch({ type: "INVOICE_IMAGE_REQUEST", value: config }),
		getInvoiceDetails: (config: any) =>
			dispatch({ type: "INVOICE_DETAILS_REQUEST", value: config }),
		getCredits: (config: any) =>
			dispatch({ type: "GET_CREDITS_REQUEST", value: config }),
		payInvoices: (config: any) =>
			dispatch({ type: "PAY_INVOICES_REQUEST", value: config }),
		getAcceptedCards: (config: any) =>
			dispatch({ type: "ACCEPTED_CARDS_REQUEST", value: config }),
		getBillingProfile: (config: any) =>
			dispatch({ type: "BILLING_PROFILE_REQUEST", value: config }),
		updateBillingProfile: (config: any) =>
			dispatch({ type: "UPDATE_BILLING_PROFILE_REQUEST", value: config }),
		createBillingProfile: (config: any) =>
			dispatch({ type: "CREATE_BILLING_PROFILE_REQUEST", value: config }),
		deleteBillingProfile: (config: any) =>
			dispatch({ type: "DELETE_BILLING_PROFILE_REQUEST", value: config }),
		defaultBillingProfile: (config: any) =>
			dispatch({ type: "DEFAULT_BILLING_PROFILE_REQUEST", value: config }),
		clearErrors: () => dispatch({ type: "CLEAR_ERRORS" }),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Invoices);
